import { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const testimonials = [
    {
        name: 'Dahlia',
        rating: 5,
        text: 'Pelayanan ramah, perjalanan lancar, dan itinerary-nya pas banget! Pasti ikut lagi!',
    },
    {
        name: 'Fajar',
        rating: 5,
        text: 'Seru banget! Anak-anak senang, orang tua pun puas. Recommended untuk liburan keluarga.',
    },
    {
        name: 'Rani',
        rating: 5,
        text: 'Kami merasa sangat diperhatikan dari awal sampai akhir. Terima kasih atas pengalaman tak terlupakannya!',
    },
    {
        name: 'Yohana',
        rating: 5,
        text: 'Pemandunya informatif dan sabar, tempat wisatanya juga bagus-bagus. Worth it banget!',
    },
];

export default function Testimonials() {
    const [start, setStart] = useState(0);
    const visible = testimonials.slice(start, start + 3);

    const next = () => {
        if (start + 3 < testimonials.length) setStart(start + 1);
    };

    const prev = () => {
        if (start > 0) setStart(start - 1);
    };

    return (
        <section
            className="relative bg-cover bg-center py-12 text-white"
            style={{ backgroundImage: "url('../image/mountain2.jpg')" }}
        >
            <div className="max-w-6xl mx-auto px-6 text-center">
                <h2 className="text-2xl font-bold mb-8">What They Say About Us</h2>

                <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-6">
                    {visible.map((t, i) => (
                        <div key={i} className="bg-white/90 text-black p-6 rounded-xl shadow-lg">
                            <p className="italic mb-4">“{t.text}”</p>
                            <div className="flex items-center gap-2">
                                <span>👤</span>
                                <span className="font-medium">{t.name}</span>
                                <span>⭐ {t.rating}</span>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="flex justify-center gap-2">
                    <button onClick={prev} className="bg-white p-2 rounded-full shadow">
                        <ChevronLeft size={18} />
                    </button>
                    <button onClick={next} className="bg-white p-2 rounded-full shadow">
                        <ChevronRight size={18} />
                    </button>
                </div>
            </div>
        </section>
    );
}
